import React, { useState } from 'react';
import Styles from './EmprestimoGarantiaCarroBanner.css';
import WhiteButton from '@/components/atoms/WhiteButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';
function EmprestimoGarantiaCarroBanner({ currentTab }) {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  console.log(currentTab);
  return (
    <>
      <section id="emp-garantia-carro-banner" className="stacked-banner">
        {currentTab === 0 && (
          <div className="bg-image-wrapper">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 320 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-320.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-320.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero/hero-320.png"
                      alt="Casal feliz com as chaves no carro após realizarem um empréstimo com garantia de veículo no Santander."
                    />
                  </picture>
                )}
                {width > 320 && width <= 450 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-450.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-450.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero/hero-450.png"
                      alt="Casal feliz com as chaves no carro após realizarem um empréstimo com garantia de veículo no Santander."
                    />
                  </picture>
                )}
                {width > 450 && width <= 800 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-800.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-800.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero/hero-800.png"
                      alt="Casal feliz com as chaves no carro após realizarem um empréstimo com garantia de veículo no Santander."
                    />
                  </picture>
                )}
                {width > 800 && width <= 1280 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-1280.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-1280.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero/hero-1280.png"
                      alt="Casal feliz com as chaves no carro após realizarem um empréstimo com garantia de veículo no Santander."
                    />
                  </picture>
                )}
                {width > 1280 && width <= 1360 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-1360.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-1360.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero/hero-1360.png"
                      alt="Casal feliz com as chaves no carro após realizarem um empréstimo com garantia de veículo no Santander."
                    />
                  </picture>
                )}
                {width > 1360 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-1440.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero/hero-1440.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero/hero-1440.png"
                      alt="Casal feliz com as chaves no carro após realizarem um empréstimo com garantia de veículo no Santander."
                    />
                  </picture>
                )}
              </>
            )}
          </div>
        )}
        {currentTab === 1 && (
          <div className="bg-image-wrapper">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 320 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-320.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-320.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-320.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 320 && width <= 450 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-450.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-450.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-450.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 450 && width <= 800 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-800.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-800.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-800.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 800 && width <= 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-992.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-992.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-992.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 992 && width <= 1280 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-1280.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-1280.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-1280.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 1280 && width <= 1360 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-1360.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-1360.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-1360.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 1360 && width <= 1440 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-1440.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-1440.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-1440.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 1440 && width <= 1920 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-1920.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-1920.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-1920.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 1920 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-2650.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/hero-contrato/hero-2650.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/hero-contrato/hero-2650.png"
                      alt="Pessoa sorridente, de óculos e camisa vermelha, sentada à frente de um notebook em um ambiente de escritório consultando seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
              </>
            )}
          </div>
        )}
        {/* <div className="fade-banner" /> */}
        {/* <div className="fade-banner-gradiente" /> */}
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Empréstimo com Garantia de Veículo</h1>
              <p className="alt-text">
                Seu veículo continua com você, mas seu crédito te leva mais longe. Conte com nosso{' '}
                <b>Empréstimo com Garantia de Veículo</b> com taxas a partir de 1,39% ao mês.
              </p>
              <div className="emp-garantia-carro-btns">
                {/* {currentTab === 0 && (
                  <WhiteButton
                    href="https://emprestimosim.com.br/app/#/onboarding/signUp"
                    target="_blank"
                    className="btn-simulate"
                  >
                    Simular
                  </WhiteButton>
                )}
                {currentTab === 1 && (
                  <WhiteButton
                    href="https://emprestimosim.com.br/app/#/login/signInWithPassword "
                    target="_blank"
                    className="btn-entrar"
                  >
                    Entrar
                  </WhiteButton>
                )} */}
                <WhiteButton
                  href="https://emprestimosim.com.br/app/#/onboarding/signUp"
                  target="_blank"
                  className="btn-simulate"
                >
                  Simular
                </WhiteButton>
                <RedButton
                  href="https://emprestimosim.com.br/app/#/login/signInWithPassword "
                  target="_blank"
                  className="btn-entrar"
                >
                  Entrar
                </RedButton>
              </div>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroBanner;
